var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"text-left mx-1 d-block hover:bg-gray-200 my-1 py-2 font-medium text-gray-800",attrs:{"href":"#"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }